import { useState, useEffect, useCallback } from 'react';

export const useLocalStorageListener = (key: string) => {
  const [currentValue, setCurrentValue] = useState<string | null>(null);

  const setValue = useCallback(
    (value: string | null) => {
      if (typeof window === 'undefined') return;

      if (!value) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, value);
      }
      setCurrentValue(value);
    },
    [key]
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const initialValue = localStorage.getItem(key);
    setCurrentValue(initialValue);

    const handleStorageChange = (event: StorageEvent) => {
      if (
        event.storageArea === localStorage &&
        event.key === key &&
        currentValue !== event.newValue
      ) {
        setCurrentValue(event.newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [key, currentValue]);

  return { setValue, currentValue };
};
